import React from 'react';
import styles from './SummaryInfoList.module.scss';
import { SFText } from 'sfui';

export interface SummaryInfoListProps {
  className?: string;
  title: string;
  children?: React.ReactNode;
}

export const SummaryInfoList = ({
  className = '',
  title,
  children
}: SummaryInfoListProps): React.ReactElement<SummaryInfoListProps> => {
  return (
    <div className={`${styles.summaryInfoList} ${className}`}>
      <SFText type="component-3-medium">{title}</SFText>
      <div className={styles.listItems}>{children}</div>
    </div>
  );
};
